<template>

  <div class="inner way">
    <div class="flex-none p-4 border-b">
      <div class="flex justify-between items-center">
        <strong class="text-xl font-medium">
          Directions
        </strong>
      </div>
      <div class="justify-between font-medium">
        <div class="block text-lg text-orange-dark">
          {{ fullTime() }}
          <span class="text-lg text-grey-dark">{{ parsedDistance.m }} miles ({{ parsedDistance.k }} km)</span>
        </div>
        <div class="block text-lg text-orange-dark" v-if='is_paused'>
          Driving time: {{ drivingTime() }}
        </div>
        <div class="text-xs pt-1 text-grey-dark">
          Vehicle Dimensions:
          H:{{ vehicles_dimensions.height.val }}m
          W:{{ vehicles_dimensions.width.val }}m
          L:{{ vehicles_dimensions.length.val }}m
          Wt:{{ vehicles_dimensions.weight.val }}t
        </div>
      </div>
    </div>
    <div class="actions save flex items-center justify-between gap-10p ">
      <button class="w_100 white-green" @click="editRoute()">Edit</button>
      <button class="w_100 green-white" @click="saveRoute">Save</button>
<!--      <button class="w_100 green-white" @click="share()">Save & Share</button>-->
    </div>
    <div class="actions selest-route flex items-center justify-between gap-10p pt-5" v-if='route_data.routes.length > 1'>
      <button class="w_100 option-btn"
              :class='{"green-white": route.id === selected_route_id,
              "white-green": route.id !== selected_route_id}'
              v-for="(route, index) in route_data.routes"
              :key="route.id"
              @click="chooseRoute(route.id)">option {{index+1}}</button>
<!--      <button class="w_100 green-white" @click="share()">Save & Share</button>-->
    </div>
    <RouteInstructions
        v-if="route_data.routes[selected_route_index].sections"
      :sections="route_data.routes[selected_route_index].sections"
    />

  </div>
</template>
<script>

import RouteInstructions from "@/components/plan-elements/RouteInstructions.vue";
import {secondsToDhms} from "@/services/helpers";

export default {
  name: 'SaveRoute',
  components: {RouteInstructions},
  props: {
    route_data: {
      type: Object,
    },
    selected_route_id: {
      type: [String, Number, null],
      default: null,
    },
    vehicles_dimensions: {
        type: Object,
        default: () => {
          return {
            width: {
              min: 1,
              max: 6,
              val: 2.5,
              step: 0.1,
              name: 'Width',
              dimention: 'm'
            },
            height: {
              min: 1,
              max: 10,
              val: 4,
              step: 0.1,
              name: 'Height',
              dimention: 'm'
            },
            length: {
              min: 1,
              max: 50,
              val: 12,
              step: 0.5,
              name: 'Length',
              dimention: 'm'
            },
            weight: {
              min: 1,
              max: 50,
              val: 18,
              step: 1,
              name: 'Weight',
              dimention: 't'
            },
          }
        }
    }
  },
  data() {
    return {
      route_name: '',
      is_paused: false,
      colors: ['#FF0000', '#00FF00'],
      selected_route_index: 0,
      parsedDistance: {
        k: null,
        m: null
      },
    }
  },
  methods: {
    editRoute() {
      this.$emit('edit_route', true)
    },
    syncSelectionFromRouteId(routeId) {
      const routes = this.route_data?.routes;
      if (!routes?.length) {
        return;
      }
      let id = routeId;
      if (id == null || id === '' || id === 0) {
        id = routes[0].id;
      }
      const index = routes.findIndex((route) => route.id === id);
      this.selected_route_index = index >= 0 ? index : 0;
      this.parseDistance();
    },
    chooseRoute(route_id) {
      this.$emit('choose_route', route_id);
    },
    saveRoute() {
      this.$emit('save_route', true)
    },
    share() {
      this.$emit('share_route')
    },

    fullTime() {
      const seconds = this.route_data.routes[this.selected_route_index].sections.reduce((acc, section) => {
        if (section.postActions && section.postActions.length > 0) {
          this.is_paused = true;
          section.postActions.forEach((action) => {
            if (action.action === 'wait') {
              acc += action.duration;
            }
          });
        }
        return acc + section.travelSummary.duration;
      }, 0);
      return secondsToDhms(seconds)
    },

    drivingTime() {
      const seconds = this.route_data.routes[this.selected_route_index].sections.reduce((acc, section) => {
        return acc + section.travelSummary.duration;
      }, 0);
      return secondsToDhms(seconds)
    },
    parseDistance() {
      const route = this.route_data?.routes?.[this.selected_route_index];
      if (!route?.sections?.length) {
        this.parsedDistance.k = null;
        this.parsedDistance.m = null;
        return;
      }
      const travelLength = route.sections.reduce((acc, section) => {
        return acc + section.travelSummary.length;
      }, 0);
      this.parsedDistance.k = Math.round(travelLength / 1000);
      this.parsedDistance.m = Math.round((travelLength / 1000) / 1.609344);
    },
    distanceToString(meters) {
      if(meters)
        return `${Math.round(meters / 1000)} Km (${Math.round((meters / 1000) / 1.609344)} miles)`;
      else return ''
    },
  },
  watch: {
    selected_route_id: {
      handler(routeId) {
        this.syncSelectionFromRouteId(routeId);
      },
      immediate: true,
    },
    route_data: {
      handler() {
        this.syncSelectionFromRouteId(this.selected_route_id);
      },
      deep: true,
    },
  },
}
</script>


<style scoped lang="scss">
.actions {
  button {
    height: 46px;
    &.white-green {
      height: 44px;
    }
    &.option-btn {
      font-size: 12px;
      padding: 5px;
      max-height: 30px;
    }
  }
}

</style>
